export default __webpack_public_path__ + "static/media/photobooth2.2020e3af.png";